import { useOverflowContext as e } from "./overflow-context.js";
import * as t from "react";
//#region src/shared/overflow/use-overflow-snapshot.ts
function n(n) {
	let { getSnapshot: i, subscribe: a } = e(), o = r(n), [s, c] = t.useState(() => n(i()));
	return t.useLayoutEffect(() => {
		let e = () => c(o(i()));
		return e(), a(e);
	}, [
		i,
		a,
		o
	]), s;
}
function r(e) {
	let n = t.useRef(e);
	return t.useLayoutEffect(() => {
		n.current = e;
	}), t.useCallback((...e) => n.current(...e), []);
}
//#endregion
export { n as useOverflowSnapshot };
